import type { ValidatorType } from "shelving";
import { DATA, INTEGER, NON_NEGATIVE_INTEGER, OPTIONAL_KEY, isArrayItem, pickProps } from "shelving";
import { CONTENT_ENTITY, CREATOR_ENTITY, ENTITIES } from "./entity.js";
import { CONTENT } from "./misc.js";

/** Comments: store comments. */
export const COMMENT_SCHEMA = DATA({
	creator: CREATOR_ENTITY,
	target: CONTENT_ENTITY,
	date: INTEGER,
	thread: OPTIONAL_KEY, // ID of another comment (for threading).
	content: CONTENT,
	tags: ENTITIES,
	replies: NON_NEGATIVE_INTEGER, // Number of replies.
	reactions: INTEGER, // Number of reactions of diferent types on this post.
});
export type CommentData = ValidatorType<typeof COMMENT_SCHEMA>;

/** Form to create a comment. */
export const COMMENT_FORM_SCHEMA = DATA(pickProps(COMMENT_SCHEMA.props, "content"));
export type CommentFormData = ValidatorType<typeof COMMENT_FORM_SCHEMA>;

/** List of entities that can have comments. */
export const COMMENTABLE_TYPES = ["post"] as const;
export type CommentableType = (typeof COMMENTABLE_TYPES)[number];
export const isCommentableType = (type: string): type is CommentableType => isArrayItem(COMMENTABLE_TYPES, type);
